module.exports = __webpack_public_path__ + "static/reinventing-nature-2010-23306139421d868971ff3890c398b048.jpg";